import React, { useMemo, useState } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Button, FormControl, Grid, IconButton, ListItemIcon, TextField } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { AddCircleOutline, Close, DeleteOutline, Edit, Send } from "@mui/icons-material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import AddUser from "../components/modals/AddUser";
import Header from "../layouts/Header";
import { instance } from "../utils/api";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
const cl = 'app-page-ticketlist';
const data = [
  {
    agentName: "John abraham",
    agentEmail: "agent@gmail.com",
    agentPhone: "9900990099",
    agentCompany: "Breative",
    numOfTickets: 30,
  },
];
function UsersList() {
  const columns = useMemo(
    () => [
      {
        accessorKey: "agentName",
        header: "Name",
        Cell: ({ renderedCellValue }) => <span className="custom-table-cell-text">{renderedCellValue}</span>
      },
      {
        accessorKey: "agentEmail",
        header: "Email",
        Cell: ({ renderedCellValue }) => <span className="custom-table-cell-text">{renderedCellValue}</span>
      },
      {
        accessorKey: "agentPhone",
        header: "Phone",
        Cell: ({ renderedCellValue }) => <span className="custom-table-cell-text">{renderedCellValue}</span>
      },
      {
        accessorKey: "agentCompany",
        header: "Company",
        Cell: ({ renderedCellValue }) => <span className="custom-table-cell-text">{renderedCellValue}</span>
      },
      {
        accessorKey: "numOfTickets",
        header: "Tickets raised",
        Cell: ({ renderedCellValue }) => <span className="custom-table-cell-text">{renderedCellValue}</span>
      },
    ],
    []
  );
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");



  const createUser = async () => {
    try {
      const userData = {
        name: name,
        company: company,
        email: email,
        phone: phone,
      };

      const response = await instance.post('create/user', userData);

      if (response === 200) {
        console.log("user added successfull")
      }

    } catch (error) {
      console.error('An error occurred while creating the user:', error);

    }
  };




  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="userlist">
        <Header />
      </div>
      <div className='app-page-body'>
        <div className='app-page-wrapper'>
          <div className={`${cl}`}>
            <div className={`${cl}__header`}>
              <h2 className={`${cl}__header--title`}>Users List</h2>
              <ul className={`${cl}__header--actions`}>
                <li className={`${cl}__header--actionsitem`}>
                  <Button variant="contained" onClick={handleClickOpen}><AddCircleOutline /> Add user</Button>
                </li>
              </ul>
            </div>
          </div>
          <div className="app-table-component">
            <MaterialReactTable columns={columns} data={data} enableRowActions
              renderRowActionMenuItems={({ closeMenu }) => [
                <MenuItem
                  key={1}
                  onClick={() => {
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <Send />
                  </ListItemIcon>
                  Send Email
                </MenuItem>,
                <MenuItem
                  key={0}
                  onClick={() => {
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <Edit />
                  </ListItemIcon>
                  Edit
                </MenuItem>,
                <MenuItem
                  key={0}
                  onClick={() => {
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <DeleteOutline />
                  </ListItemIcon>
                  Delete
                </MenuItem>,
              ]}
              positionActionsColumn="last"
            />
          </div>
        </div>
      </div>
      <BootstrapDialog
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Add user
        </DialogTitle>
        <IconButton
          size="small"
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 10,
            top: 14,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <div>
            <div className={`${cl}`}>
              <div className={`${cl}__card`}>
                <Grid container spacing={3}>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField size="medium"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required id="outlined-basic" label="Name" placeholder="Enter name" type="primary" variant="outlined" />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField size="medium" value={company}
                          onChange={(e) => setCompany(e.target.value)}
                          required id="outlined-basic" label="Company" placeholder="Enter company" type="primary" variant="outlined" />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField size="medium"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required id="outlined-basic" label="Email" placeholder="Enter email" type="primary" variant="outlined" />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField size="medium"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required id="outlined-basic" label="Phone" placeholder="Enter phone" type="primary" variant="outlined" />
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button type="primary" variant="contained" autoFocus onClick={createUser}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  )
}
export default UsersList;
